import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { lighten, rem } from 'polished';
import { baseTheme } from '~base-theme';
import loaderTheme from '../../styles/loaderTheme';
var DashContainer = styled.span.withConfig({
  displayName: "DashContainer",
  componentId: "sc-12v5gtb-0"
})(["background-color:", ";border-radius:", ";height:", ";overflow:hidden;position:relative;width:", "em;", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'loader.container.backgroundColor', loaderTheme.loader.container.backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme;
  return rem(_get(theme, 'loader.height', loaderTheme.loader.height) / 2);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'loader.height', loaderTheme.loader.height));
}, function (_ref4) {
  var theme = _ref4.theme,
      isFullScreen = _ref4.isFullScreen;
  return isFullScreen ? _get(theme, 'loader.width.isFullScreen', loaderTheme.loader.width.isFullScreen) : _get(theme, 'loader.width.default', loaderTheme.loader.width.default);
}, function (_ref5) {
  var theme = _ref5.theme,
      skin = _ref5.skin;
  return skin && css(["background-color:", ";"], lighten(0.5, _get(theme, "base.colors." + skin, baseTheme.base.colors[skin])));
});
export default DashContainer;